<template>
  <div style="font-family: 'Source Sans 3'; background: #e2e2e2">
    <div class="header-solutions">
      <span class="header-font">Capacitación</span>
    </div>
    <div class="course-catalog-container mt-4 mb-4">
      <div class="text-left mb-4" style="font-size: 36px; color: #006ec8">
        <strong>Catálogo de cursos</strong> de capacitación,
        <div>formación y desarrollo docente</div>
      </div>
    </div>
    <div class="course-catalog-class mt-5 mr-5 ml-5">
      <div class="course-catalog-card" style="color: #006ec8">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard1')"
          >
            <img
              style="margin: auto"
              class="w-50 h-50"
              :src="training_card_icon_1"
            />
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Diseño de experiencias </strong> de aprendizaje
        </div>
      </div>
      <div class="course-catalog-card" style="color: #01adb7">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard2')"
          >
            <svg
              class="w-50 h-50"
              style="margin: auto"
              width="39"
              height="40"
              viewBox="0 0 39 40"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.000781512 29.3273C0.722194 28.5099 1.44283 27.6909 2.16658 26.875C2.28916 26.7368 2.40003 26.608 2.39847 26.4026C2.3688 23.0196 3.13471 19.7912 4.28085 16.6331C4.61267 15.7181 4.88359 14.7851 5.09361 13.831C5.37234 12.5623 6.56767 11.7245 7.89104 11.8799C8.2861 11.9267 8.31342 11.7862 8.31264 11.4708C8.30405 8.66556 8.36417 5.85876 8.28922 3.05587C8.23378 1.03373 9.9936 -0.0054438 11.3662 2.14454e-05C15.7165 0.0179787 20.0668 0.0117327 24.4172 0.00314444C25.9045 2.14454e-05 27.5386 1.05716 27.5238 3.13004C27.4894 7.90901 27.5128 12.688 27.5121 17.4669C27.5121 17.6613 27.5245 17.8565 27.4613 18.0463C27.3528 18.3703 27.1318 18.5389 26.7875 18.5178C26.4416 18.4967 26.241 18.293 26.1785 17.9643C26.1496 17.8136 26.1606 17.6535 26.1606 17.4982C26.1598 13.4203 26.1598 9.34247 26.1598 5.26461C26.1598 4.71262 26.159 4.71106 25.5984 4.71106C20.4556 4.71106 15.3136 4.71106 10.1708 4.71106C9.61103 4.71106 9.61025 4.71184 9.61025 5.26305C9.61025 7.57485 9.61259 9.88665 9.60712 12.1977C9.60634 12.4772 9.65475 12.7247 9.79372 12.9753C10.1818 13.6709 10.284 14.4517 10.3605 15.2254C10.5565 17.2171 10.4566 19.1955 9.91162 21.1287C9.78435 21.5791 9.81871 21.9281 10.0279 22.338C10.7782 23.8097 11.1944 25.3892 11.3919 27.0233C11.4364 27.3934 11.5582 27.5441 11.947 27.5261C12.5818 27.4972 13.2197 27.5144 13.856 27.5206C14.3869 27.5261 14.6765 27.7705 14.6758 28.1976C14.6758 28.6231 14.39 28.8643 13.8513 28.8713C13.215 28.8792 12.5787 28.8823 11.9423 28.8706C11.6667 28.8651 11.541 28.9463 11.5473 29.2453C11.5574 29.7505 11.5754 30.2587 11.4879 30.7608C11.4341 31.0684 11.6207 31.0949 11.8596 31.0941C13.2103 31.0895 14.561 31.0879 15.9109 31.0941C16.4137 31.0965 16.7182 31.4463 16.6089 31.8928C16.5175 32.2668 16.2427 32.3956 15.8758 32.3941C14.5383 32.3894 13.2001 32.412 11.8635 32.3816C11.431 32.3714 11.2678 32.5042 11.2202 32.9273C11.1647 33.4145 10.8228 33.6589 10.4246 33.5754C10.0256 33.4918 9.84213 33.1584 9.92255 32.672C10.3988 29.77 10.3184 26.907 9.32762 24.1072C9.0973 23.4568 8.81778 22.8291 8.45942 22.2389C8.31498 22.0015 8.23769 21.7462 8.36495 21.4995C8.76704 20.7195 8.88884 19.8724 8.98096 19.0206C9.15429 17.4139 9.17537 15.8071 8.83574 14.2167C8.64524 13.3243 7.87386 12.9558 7.03846 13.3266C6.75349 13.4531 6.50365 13.6522 6.43884 13.9559C5.94073 16.2989 4.95308 18.4944 4.38391 20.8148C3.9303 22.6644 3.74291 24.546 3.75697 26.4479C3.76009 26.8898 3.64142 27.2427 3.33536 27.5722C2.62722 28.3318 1.94875 29.1188 1.25857 29.8949C0.818225 30.3899 0.439562 30.3837 0 29.873C0.00078075 29.6911 0.000781512 29.5092 0.000781512 29.3273ZM17.8542 3.3588C20.4127 3.3588 22.9704 3.3588 25.5289 3.3588C25.6328 3.3588 25.7374 3.35256 25.8405 3.3588C26.0747 3.37442 26.1543 3.26746 26.1637 3.03635C26.1934 2.30401 25.8803 1.79418 25.2065 1.4975C24.8981 1.36243 24.5764 1.35696 24.2516 1.35696C20.0184 1.35696 15.7852 1.35696 11.5512 1.35774C11.3693 1.35774 11.1866 1.35696 11.0062 1.37726C10.2263 1.46783 9.63601 2.09868 9.61102 2.85912C9.59541 3.34397 9.60556 3.35724 10.1013 3.35724C12.6864 3.3588 15.2699 3.3588 17.8542 3.3588Z"
              />
              <path
                d="M27.038 39.9253C26.632 39.6122 26.5282 39.1219 26.333 38.6902C26.2127 38.4239 26.0457 38.2498 25.7779 38.1319C24.9346 37.7611 24.1016 37.366 23.2592 36.992C22.9453 36.8523 22.6752 36.6696 22.4378 36.4182C21.6625 35.5968 20.8701 34.7919 20.094 33.9705C19.9051 33.7707 19.8036 33.7145 19.5951 33.9776C18.068 35.9076 16.0763 36.9475 13.6068 37.0803C13.1243 37.106 12.648 37.0904 12.1702 37.0623C11.943 37.049 11.7806 37.1216 11.6237 37.2872C11.1162 37.8259 10.5962 38.3521 10.0762 38.8791C9.7116 39.2492 9.3103 39.2906 9.01986 38.9978C8.73488 38.7097 8.76299 38.3482 9.12135 37.9703C9.74673 37.3106 10.3869 36.6657 11.0069 36.0013C11.2419 35.7499 11.5019 35.646 11.8391 35.6913C12.9853 35.8459 14.1213 35.7897 15.2299 35.4563C16.6306 35.0355 17.758 34.2196 18.6317 33.0454C18.819 32.7932 18.8229 32.6214 18.5848 32.3848C17.8845 31.6908 17.2138 30.9654 16.5268 30.2573C16.2512 29.9731 16.0419 29.6483 15.8951 29.2837C15.5657 28.4631 15.8569 27.6441 16.6384 27.2249C17.3536 26.8407 18.1109 26.7611 18.9026 26.9383C19.8567 27.1507 20.6967 27.6082 21.5103 28.1266C21.6188 28.1953 21.7273 28.2648 21.9288 28.3929C21.593 27.6199 21.2987 26.9376 20.9997 26.2575C19.663 23.2149 18.3209 20.1755 16.989 17.1313C16.3378 15.6432 17.1443 14.1091 18.7066 13.8366C19.681 13.6664 20.7311 14.2582 21.1644 15.238C21.8624 16.8167 22.5557 18.3977 23.2396 19.9826C23.363 20.2676 23.4379 20.3754 23.7432 20.1302C24.6286 19.4197 25.8278 19.4744 26.6624 20.2489C26.8709 20.4417 26.9747 20.4495 27.1926 20.2567C28.0647 19.483 29.2085 19.4634 30.1469 20.2059C30.3874 20.3957 30.5225 20.398 30.7629 20.1989C32.0137 19.1605 33.7204 19.6009 34.3989 21.1272C35.0945 22.6926 35.7769 24.265 36.4648 25.8336C37.0589 27.189 37.646 28.5467 38.2534 29.8966C38.4096 30.244 38.4416 30.5891 38.408 30.9576C38.3565 31.526 38.33 32.096 38.2761 32.6643C38.2355 33.0922 38.3151 33.4857 38.5087 33.8675C38.6204 34.0869 38.7203 34.3156 38.7922 34.5499C38.8976 34.8934 38.7352 35.2213 38.4229 35.3564C38.1215 35.4868 37.7725 35.4001 37.6187 35.0862C37.2158 34.2657 36.7341 33.4693 36.9566 32.4707C37.0597 32.0077 37.0245 31.5151 37.062 31.0365C37.0878 30.7047 37.0214 30.4017 36.8856 30.0957C35.6934 27.4013 34.5113 24.7023 33.3261 22.0048C33.2582 21.8502 33.1848 21.6979 33.1083 21.548C32.8554 21.0546 32.3502 20.8641 31.8638 21.0765C31.3953 21.2802 31.183 21.7651 31.3719 22.2788C31.5335 22.7168 31.735 23.1392 31.9184 23.5694C31.995 23.7482 32.0793 23.9246 32.1441 24.1081C32.2807 24.4969 32.1464 24.8428 31.8099 24.9943C31.4734 25.1457 31.1221 25.0169 30.9417 24.6351C30.6318 23.9777 30.3452 23.3094 30.0501 22.6458C29.9127 22.3374 29.787 22.0243 29.641 21.7198C29.3498 21.1124 28.8267 20.8688 28.3262 21.0975C27.8164 21.3302 27.647 21.851 27.9038 22.4865C28.142 23.076 28.4098 23.6529 28.6635 24.2369C28.7408 24.4157 28.8259 24.5922 28.8852 24.7772C29.0117 25.1684 28.8595 25.5072 28.5105 25.6431C28.1841 25.7703 27.8445 25.6392 27.6743 25.2777C27.3917 24.6796 27.1348 24.0691 26.8654 23.464C26.5859 22.8355 26.3095 22.2062 26.0214 21.5816C25.8778 21.2693 25.6397 21.0585 25.286 21.0117C24.5029 20.9094 24.0063 21.5668 24.3108 22.3655C24.6161 23.165 24.9854 23.9395 25.3274 24.7257C25.4726 25.0591 25.624 25.3893 25.7599 25.7266C25.934 26.1576 25.8067 26.5362 25.4531 26.6799C25.083 26.8306 24.7348 26.6815 24.5435 26.2489C23.6495 24.2315 22.7673 22.2093 21.878 20.1895C21.2292 18.7163 20.5851 17.2414 19.923 15.7744C19.6841 15.2451 19.1423 15.0303 18.6676 15.2294C18.1858 15.4324 17.9797 15.9961 18.1882 16.5458C18.2155 16.6184 18.246 16.6902 18.2772 16.762C19.0548 18.5328 19.8332 20.3035 20.6109 22.0743C21.5923 24.3088 22.5635 26.5472 23.5597 28.7747C23.8096 29.3337 23.6808 29.849 23.4793 30.3533C23.3122 30.7718 22.7868 30.8265 22.3933 30.4868C21.8327 30.0012 21.2503 29.546 20.6226 29.1518C19.9605 28.7364 19.2773 28.3663 18.4958 28.2203C18.1413 28.154 17.7994 28.1789 17.4644 28.314C17.0741 28.4717 17.0163 28.6294 17.2287 29.0003C17.3981 29.297 17.6588 29.5203 17.8907 29.7631C19.7185 31.6798 21.5556 33.588 23.3872 35.5008C23.5074 35.6265 23.6534 35.7046 23.808 35.7749C24.7879 36.2222 25.7654 36.6758 26.7483 37.1162C27.038 37.2458 27.2371 37.4394 27.3565 37.7345C27.5025 38.0952 27.6727 38.4466 27.825 38.8049C28.0623 39.3655 28.0311 39.4982 27.5783 39.93C27.4018 39.9253 27.2199 39.9253 27.038 39.9253Z"
              />
            </svg>
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Tecnología </strong>para el Aprendizaje
        </div>
      </div>
      <div class="course-catalog-card" style="color: #006ec8">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard3')"
          >
            <img
              style="margin: auto"
              class="w-50 h-50"
              :src="training_card_icon_3"
            />
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Estrategias integradoras </strong>(pedagogía colaborativa)
        </div>
      </div>
      <div class="course-catalog-card" style="color: #01adb7">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard4')"
          >
            <svg
              style="margin: auto"
              class="w-50 h-50"
              width="42"
              height="37"
              viewBox="0 0 42 37"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34.5469 0C34.8315 0.232108 34.9051 0.533767 34.9035 0.894464C34.8938 4.17551 34.8987 7.45656 34.8971 10.7384C34.8971 11.4525 34.7013 11.6466 33.9872 11.6482C33.3823 11.6499 32.7749 11.6757 32.1716 11.6393C31.7462 11.6143 31.6403 11.7712 31.6605 12.1691C31.6912 12.7724 31.6605 13.3789 31.6718 13.9839C31.6783 14.3422 31.6338 14.6689 31.2585 14.8217C30.8922 14.9714 30.6196 14.7999 30.3641 14.5411C29.5141 13.6798 28.6479 12.8339 27.8028 11.9669C27.5788 11.7372 27.3507 11.6119 27.0256 11.6434C26.8129 11.6644 26.5937 11.6596 26.3811 11.6361C26.0325 11.5981 25.8044 11.3223 25.8044 10.973C25.8044 10.6228 26.0325 10.3316 26.3827 10.3146C26.8792 10.2896 27.3774 10.3025 27.8748 10.313C28.0923 10.3179 28.2355 10.4764 28.3786 10.6203C28.9933 11.2398 29.6087 11.8601 30.3204 12.5775C30.3204 12.0437 30.3196 11.6272 30.3204 11.2107C30.3228 10.4942 30.5145 10.3017 31.2286 10.3001C31.874 10.2985 32.5202 10.2912 33.1655 10.3033C33.4316 10.3082 33.5537 10.237 33.5529 9.94262C33.5448 7.18563 33.544 4.42946 33.5537 1.67247C33.5554 1.33199 33.3782 1.31582 33.1211 1.31663C30.7401 1.32148 28.3592 1.31905 25.9783 1.31905C23.5302 1.31905 21.0822 1.32067 18.6342 1.31663C18.3543 1.31582 18.1311 1.3231 17.9936 1.64902C17.8723 1.93612 17.5699 2.0178 17.2674 1.9434C16.9641 1.86819 16.7724 1.65872 16.7676 1.33846C16.7603 0.865348 16.6398 0.355037 17.1105 0.000809527C22.9237 7.89801e-07 28.7353 0 34.5469 0Z"
              />
              <path
                d="M0 32.1161C0.424587 30.5965 1.42904 29.7829 2.97777 29.4845C5.56007 28.9871 8.15289 28.9354 10.7627 29.0955C11.0708 29.1141 11.3806 29.1012 11.6855 29.1723C12.1117 29.271 12.3349 29.5468 12.2904 29.9374C12.25 30.2941 11.9701 30.5342 11.548 30.5221C10.85 30.5019 10.1529 30.4598 9.45576 30.4178C7.27055 30.2852 5.10799 30.4582 2.96888 30.9127C1.87951 31.144 1.33442 31.8234 1.3231 32.9321C1.31501 33.7118 1.31501 34.4914 1.3239 35.2702C1.32795 35.6244 1.29722 35.9544 0.926005 36.1186C0.540237 36.2892 0.254752 36.1008 0.000808738 35.8282C0 34.5901 0 33.3527 0 32.1161Z"
              />
              <path
                d="M11.0053 15.7965C11.7049 15.0945 12.3187 14.4936 12.9147 13.8741C13.1574 13.6218 13.4242 13.5224 13.7728 13.5232C16.7457 13.5321 19.7187 13.5288 22.6916 13.528C23.2164 13.528 23.2173 13.5264 23.2181 12.991C23.2181 10.3553 23.2181 7.71965 23.2181 5.08398C23.2181 4.54859 23.2173 4.54779 22.6916 4.54698C19.1137 4.54698 15.5351 4.54698 11.9572 4.54617C11.8092 4.54617 11.6596 4.55425 11.514 4.53404C11.1703 4.48551 10.9414 4.20569 10.9544 3.85631C10.9673 3.49885 11.1606 3.2813 11.5067 3.21337C11.6369 3.18749 11.7744 3.19962 11.9095 3.19962C15.8108 3.19881 19.7114 3.19881 23.6127 3.19962C24.3851 3.19962 24.5662 3.37916 24.5662 4.14665C24.567 7.41476 24.567 10.6821 24.5662 13.9502C24.5662 14.6885 24.377 14.8754 23.6313 14.8762C20.5104 14.877 17.3895 14.8802 14.2686 14.8713C13.9758 14.8705 13.7647 14.953 13.5593 15.1625C12.7037 16.0375 11.8286 16.8932 10.9689 17.7642C10.7142 18.0222 10.4432 18.1993 10.0761 18.0537C9.70001 17.9041 9.64906 17.5806 9.65472 17.2207C9.66523 16.5616 9.64744 15.9025 9.662 15.2442C9.66847 14.9603 9.56172 14.8673 9.28432 14.8721C8.59851 14.8859 7.9127 14.8802 7.22608 14.8746C6.66563 14.8705 6.43109 14.6457 6.43028 14.0957C6.42705 10.7201 6.42705 7.34521 6.43028 3.96954C6.43109 3.44062 6.66724 3.20609 7.19535 3.20205C8.00247 3.19558 8.80959 3.19476 9.61671 3.20285C10.0809 3.2069 10.3551 3.4665 10.3551 3.8733C10.3551 4.28009 10.0801 4.53727 9.61671 4.54536C9.11934 4.55345 8.62115 4.55749 8.12378 4.54455C7.85932 4.53727 7.77279 4.64241 7.7736 4.9004C7.77926 7.65738 7.78007 10.4144 7.77279 13.1705C7.77198 13.4641 7.89329 13.5369 8.16017 13.5321C8.84598 13.5199 9.5326 13.524 10.2184 13.5304C10.7724 13.5353 10.998 13.7634 11.0045 14.319C11.0094 14.7718 11.0053 15.2247 11.0053 15.7965Z"
              />
              <path
                d="M12.9423 23.2399C12.9665 23.9945 12.9487 24.7409 12.6738 25.4631C11.916 27.4518 9.99604 28.635 7.86016 28.4183C5.85611 28.2145 4.10519 26.5646 3.8933 24.5032C3.76957 23.3014 3.68708 22.064 4.16585 20.8824C4.96246 18.9164 7.10965 17.7057 9.14767 18.0972C11.3766 18.525 12.9221 20.3244 12.9415 22.5145C12.9439 22.7563 12.9423 22.9981 12.9423 23.2399ZM11.5933 23.337C11.5941 22.8978 11.5884 22.5517 11.5399 22.2031C11.3191 20.6042 9.99038 19.4122 8.4004 19.4025C6.82417 19.3936 5.46306 20.5978 5.25279 22.1902C5.15736 22.9124 5.15008 23.637 5.2625 24.3568C5.45336 25.5764 6.14321 26.4239 7.28758 26.8542C8.43437 27.2852 9.5108 27.083 10.4538 26.2961C11.4089 25.5003 11.6459 24.4239 11.5933 23.337Z"
              />
              <path
                d="M25.2108 23.2424C25.2366 24.0107 25.2124 24.7693 24.9269 25.5028C24.1586 27.4761 22.1804 28.6722 20.0866 28.4143C18.0736 28.166 16.3688 26.5445 16.1618 24.5008C16.0397 23.2982 15.9564 22.0616 16.4359 20.8801C17.2326 18.9156 19.3822 17.7058 21.4194 18.0972C23.6483 18.5258 25.1913 20.3245 25.2108 22.5161C25.2124 22.7588 25.2108 23.0006 25.2108 23.2424ZM23.8642 23.3799C23.861 22.9157 23.8602 22.5687 23.8116 22.2201C23.5844 20.593 22.2297 19.3807 20.647 19.4025C19.0482 19.4251 17.7348 20.6027 17.5197 22.2129C17.425 22.9213 17.4202 23.6322 17.5294 24.339C17.7202 25.5756 18.4141 26.4345 19.5787 26.8607C20.7449 27.2877 21.8286 27.0685 22.7708 26.2533C23.6855 25.4632 23.9087 24.4102 23.8642 23.3799Z"
              />
              <path
                d="M28.402 23.2173C28.3576 22.4482 28.3875 21.6912 28.6746 20.9576C29.4413 19.0045 31.3782 17.8311 33.4874 18.0624C35.5028 18.2832 37.2415 19.9403 37.4373 21.9928C37.5521 23.1962 37.6378 24.4328 37.1542 25.6135C36.3802 27.502 34.4061 28.6641 32.3576 28.415C30.3325 28.1683 28.6455 26.4926 28.4093 24.4651C28.3608 24.0543 28.402 23.6338 28.402 23.2173ZM36.1279 23.2674C36.1409 22.876 36.1206 22.5161 36.0721 22.1546C35.8651 20.6042 34.4975 19.4 32.931 19.4016C31.362 19.4033 29.9985 20.6026 29.7947 22.157C29.6984 22.893 29.6863 23.6305 29.802 24.3632C29.9953 25.5828 30.6883 26.4271 31.8335 26.8558C32.9649 27.2787 34.0317 27.0838 34.9682 26.3163C35.9419 25.5197 36.1861 24.432 36.1279 23.2674Z"
              />
              <path
                d="M29.0855 33.9658C29.0847 34.4632 29.092 34.9605 29.0831 35.4579C29.075 35.8954 28.8202 36.1656 28.4304 36.1745C28.022 36.1842 27.7462 35.9092 27.7414 35.4547C27.7325 34.6346 27.7414 33.8146 27.7365 32.9945C27.73 31.8129 27.1971 31.136 26.0325 30.895C23.8101 30.434 21.565 30.2965 19.2973 30.409C17.9112 30.4777 16.5387 30.6192 15.1841 30.9201C14.1732 31.1449 13.6111 31.8202 13.5917 32.8635C13.5763 33.6965 13.5909 34.5311 13.586 35.3641C13.5836 35.8938 13.3386 36.1793 12.9043 36.1745C12.4756 36.1696 12.2419 35.8841 12.2403 35.3471C12.2371 34.4866 12.2362 33.6261 12.2403 32.7656C12.2476 31.2266 13.2415 29.9455 14.7352 29.6059C16.284 29.2533 17.8537 29.0495 19.4461 29.0212C21.8165 28.9783 24.1773 29.0357 26.4999 29.5841C28.1004 29.9617 29.0782 31.1926 29.0847 32.8368C29.0871 33.2129 29.0863 33.5889 29.0855 33.9658Z"
              />
              <path
                d="M33.0766 29.0277C34.9593 28.9574 36.8784 29.166 38.7757 29.5882C40.3479 29.9375 41.3475 31.1935 41.354 32.8037C41.3572 33.6505 41.3572 34.498 41.354 35.3448C41.3524 35.8818 41.1195 36.1689 40.6916 36.1753C40.246 36.1818 40.0091 35.8923 40.0075 35.3278C40.005 34.5482 40.0107 33.7677 40.0058 32.9881C39.9986 31.8227 39.4688 31.1418 38.3334 30.904C36.2056 30.4592 34.0551 30.2845 31.8821 30.4171C31.2116 30.4584 30.5404 30.498 29.8691 30.5223C29.3604 30.5409 29.0628 30.3088 29.0345 29.906C29.0046 29.4927 29.2415 29.2202 29.7527 29.1555C30.8347 29.0188 31.9241 29.0059 33.0766 29.0277Z"
              />
              <path
                d="M12.2549 8.36815C12.6495 8.36168 12.9415 8.6504 12.9382 9.04425C12.935 9.42112 12.6576 9.70095 12.2816 9.70742C11.8877 9.71389 11.5949 9.42436 11.5982 9.03051C11.6014 8.65282 11.8772 8.37462 12.2549 8.36815Z"
              />
              <path
                d="M16.1675 9.04512C16.1643 9.42199 15.8869 9.70181 15.51 9.70828C15.1161 9.71475 14.8242 9.42441 14.8274 9.03137C14.8307 8.63832 15.1283 8.35526 15.5246 8.36901C15.899 8.38114 16.1707 8.66744 16.1675 9.04512Z"
              />
              <path
                d="M18.7457 9.70841C18.3673 9.71811 18.0753 9.45123 18.0567 9.0784C18.0365 8.68212 18.3147 8.37884 18.7061 8.36914C19.1016 8.35943 19.396 8.64573 19.396 9.03877C19.396 9.41484 19.121 9.6987 18.7457 9.70841Z"
              />
            </svg>
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Retroalimentación Efectiva </strong>para el Aprendizaje
        </div>
      </div>
      <div class="course-catalog-card" style="color: #006ec8">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard5')"
          >
            <img
              style="margin: auto"
              class="w-50 h-50"
              :src="training_card_icon_1"
            />
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Evaluación del aprendizaje </strong>en un modelo basado en
          competencias
        </div>
      </div>
      <div class="course-catalog-card" style="color: #01adb7">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard6')"
          >
            <svg
              class="w-50 h-50"
              style="margin: auto"
              width="39"
              height="40"
              viewBox="0 0 39 40"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.000781512 29.3273C0.722194 28.5099 1.44283 27.6909 2.16658 26.875C2.28916 26.7368 2.40003 26.608 2.39847 26.4026C2.3688 23.0196 3.13471 19.7912 4.28085 16.6331C4.61267 15.7181 4.88359 14.7851 5.09361 13.831C5.37234 12.5623 6.56767 11.7245 7.89104 11.8799C8.2861 11.9267 8.31342 11.7862 8.31264 11.4708C8.30405 8.66556 8.36417 5.85876 8.28922 3.05587C8.23378 1.03373 9.9936 -0.0054438 11.3662 2.14454e-05C15.7165 0.0179787 20.0668 0.0117327 24.4172 0.00314444C25.9045 2.14454e-05 27.5386 1.05716 27.5238 3.13004C27.4894 7.90901 27.5128 12.688 27.5121 17.4669C27.5121 17.6613 27.5245 17.8565 27.4613 18.0463C27.3528 18.3703 27.1318 18.5389 26.7875 18.5178C26.4416 18.4967 26.241 18.293 26.1785 17.9643C26.1496 17.8136 26.1606 17.6535 26.1606 17.4982C26.1598 13.4203 26.1598 9.34247 26.1598 5.26461C26.1598 4.71262 26.159 4.71106 25.5984 4.71106C20.4556 4.71106 15.3136 4.71106 10.1708 4.71106C9.61103 4.71106 9.61025 4.71184 9.61025 5.26305C9.61025 7.57485 9.61259 9.88665 9.60712 12.1977C9.60634 12.4772 9.65475 12.7247 9.79372 12.9753C10.1818 13.6709 10.284 14.4517 10.3605 15.2254C10.5565 17.2171 10.4566 19.1955 9.91162 21.1287C9.78435 21.5791 9.81871 21.9281 10.0279 22.338C10.7782 23.8097 11.1944 25.3892 11.3919 27.0233C11.4364 27.3934 11.5582 27.5441 11.947 27.5261C12.5818 27.4972 13.2197 27.5144 13.856 27.5206C14.3869 27.5261 14.6765 27.7705 14.6758 28.1976C14.6758 28.6231 14.39 28.8643 13.8513 28.8713C13.215 28.8792 12.5787 28.8823 11.9423 28.8706C11.6667 28.8651 11.541 28.9463 11.5473 29.2453C11.5574 29.7505 11.5754 30.2587 11.4879 30.7608C11.4341 31.0684 11.6207 31.0949 11.8596 31.0941C13.2103 31.0895 14.561 31.0879 15.9109 31.0941C16.4137 31.0965 16.7182 31.4463 16.6089 31.8928C16.5175 32.2668 16.2427 32.3956 15.8758 32.3941C14.5383 32.3894 13.2001 32.412 11.8635 32.3816C11.431 32.3714 11.2678 32.5042 11.2202 32.9273C11.1647 33.4145 10.8228 33.6589 10.4246 33.5754C10.0256 33.4918 9.84213 33.1584 9.92255 32.672C10.3988 29.77 10.3184 26.907 9.32762 24.1072C9.0973 23.4568 8.81778 22.8291 8.45942 22.2389C8.31498 22.0015 8.23769 21.7462 8.36495 21.4995C8.76704 20.7195 8.88884 19.8724 8.98096 19.0206C9.15429 17.4139 9.17537 15.8071 8.83574 14.2167C8.64524 13.3243 7.87386 12.9558 7.03846 13.3266C6.75349 13.4531 6.50365 13.6522 6.43884 13.9559C5.94073 16.2989 4.95308 18.4944 4.38391 20.8148C3.9303 22.6644 3.74291 24.546 3.75697 26.4479C3.76009 26.8898 3.64142 27.2427 3.33536 27.5722C2.62722 28.3318 1.94875 29.1188 1.25857 29.8949C0.818225 30.3899 0.439562 30.3837 0 29.873C0.00078075 29.6911 0.000781512 29.5092 0.000781512 29.3273ZM17.8542 3.3588C20.4127 3.3588 22.9704 3.3588 25.5289 3.3588C25.6328 3.3588 25.7374 3.35256 25.8405 3.3588C26.0747 3.37442 26.1543 3.26746 26.1637 3.03635C26.1934 2.30401 25.8803 1.79418 25.2065 1.4975C24.8981 1.36243 24.5764 1.35696 24.2516 1.35696C20.0184 1.35696 15.7852 1.35696 11.5512 1.35774C11.3693 1.35774 11.1866 1.35696 11.0062 1.37726C10.2263 1.46783 9.63601 2.09868 9.61102 2.85912C9.59541 3.34397 9.60556 3.35724 10.1013 3.35724C12.6864 3.3588 15.2699 3.3588 17.8542 3.3588Z"
              />
              <path
                d="M27.038 39.9253C26.632 39.6122 26.5282 39.1219 26.333 38.6902C26.2127 38.4239 26.0457 38.2498 25.7779 38.1319C24.9346 37.7611 24.1016 37.366 23.2592 36.992C22.9453 36.8523 22.6752 36.6696 22.4378 36.4182C21.6625 35.5968 20.8701 34.7919 20.094 33.9705C19.9051 33.7707 19.8036 33.7145 19.5951 33.9776C18.068 35.9076 16.0763 36.9475 13.6068 37.0803C13.1243 37.106 12.648 37.0904 12.1702 37.0623C11.943 37.049 11.7806 37.1216 11.6237 37.2872C11.1162 37.8259 10.5962 38.3521 10.0762 38.8791C9.7116 39.2492 9.3103 39.2906 9.01986 38.9978C8.73488 38.7097 8.76299 38.3482 9.12135 37.9703C9.74673 37.3106 10.3869 36.6657 11.0069 36.0013C11.2419 35.7499 11.5019 35.646 11.8391 35.6913C12.9853 35.8459 14.1213 35.7897 15.2299 35.4563C16.6306 35.0355 17.758 34.2196 18.6317 33.0454C18.819 32.7932 18.8229 32.6214 18.5848 32.3848C17.8845 31.6908 17.2138 30.9654 16.5268 30.2573C16.2512 29.9731 16.0419 29.6483 15.8951 29.2837C15.5657 28.4631 15.8569 27.6441 16.6384 27.2249C17.3536 26.8407 18.1109 26.7611 18.9026 26.9383C19.8567 27.1507 20.6967 27.6082 21.5103 28.1266C21.6188 28.1953 21.7273 28.2648 21.9288 28.3929C21.593 27.6199 21.2987 26.9376 20.9997 26.2575C19.663 23.2149 18.3209 20.1755 16.989 17.1313C16.3378 15.6432 17.1443 14.1091 18.7066 13.8366C19.681 13.6664 20.7311 14.2582 21.1644 15.238C21.8624 16.8167 22.5557 18.3977 23.2396 19.9826C23.363 20.2676 23.4379 20.3754 23.7432 20.1302C24.6286 19.4197 25.8278 19.4744 26.6624 20.2489C26.8709 20.4417 26.9747 20.4495 27.1926 20.2567C28.0647 19.483 29.2085 19.4634 30.1469 20.2059C30.3874 20.3957 30.5225 20.398 30.7629 20.1989C32.0137 19.1605 33.7204 19.6009 34.3989 21.1272C35.0945 22.6926 35.7769 24.265 36.4648 25.8336C37.0589 27.189 37.646 28.5467 38.2534 29.8966C38.4096 30.244 38.4416 30.5891 38.408 30.9576C38.3565 31.526 38.33 32.096 38.2761 32.6643C38.2355 33.0922 38.3151 33.4857 38.5087 33.8675C38.6204 34.0869 38.7203 34.3156 38.7922 34.5499C38.8976 34.8934 38.7352 35.2213 38.4229 35.3564C38.1215 35.4868 37.7725 35.4001 37.6187 35.0862C37.2158 34.2657 36.7341 33.4693 36.9566 32.4707C37.0597 32.0077 37.0245 31.5151 37.062 31.0365C37.0878 30.7047 37.0214 30.4017 36.8856 30.0957C35.6934 27.4013 34.5113 24.7023 33.3261 22.0048C33.2582 21.8502 33.1848 21.6979 33.1083 21.548C32.8554 21.0546 32.3502 20.8641 31.8638 21.0765C31.3953 21.2802 31.183 21.7651 31.3719 22.2788C31.5335 22.7168 31.735 23.1392 31.9184 23.5694C31.995 23.7482 32.0793 23.9246 32.1441 24.1081C32.2807 24.4969 32.1464 24.8428 31.8099 24.9943C31.4734 25.1457 31.1221 25.0169 30.9417 24.6351C30.6318 23.9777 30.3452 23.3094 30.0501 22.6458C29.9127 22.3374 29.787 22.0243 29.641 21.7198C29.3498 21.1124 28.8267 20.8688 28.3262 21.0975C27.8164 21.3302 27.647 21.851 27.9038 22.4865C28.142 23.076 28.4098 23.6529 28.6635 24.2369C28.7408 24.4157 28.8259 24.5922 28.8852 24.7772C29.0117 25.1684 28.8595 25.5072 28.5105 25.6431C28.1841 25.7703 27.8445 25.6392 27.6743 25.2777C27.3917 24.6796 27.1348 24.0691 26.8654 23.464C26.5859 22.8355 26.3095 22.2062 26.0214 21.5816C25.8778 21.2693 25.6397 21.0585 25.286 21.0117C24.5029 20.9094 24.0063 21.5668 24.3108 22.3655C24.6161 23.165 24.9854 23.9395 25.3274 24.7257C25.4726 25.0591 25.624 25.3893 25.7599 25.7266C25.934 26.1576 25.8067 26.5362 25.4531 26.6799C25.083 26.8306 24.7348 26.6815 24.5435 26.2489C23.6495 24.2315 22.7673 22.2093 21.878 20.1895C21.2292 18.7163 20.5851 17.2414 19.923 15.7744C19.6841 15.2451 19.1423 15.0303 18.6676 15.2294C18.1858 15.4324 17.9797 15.9961 18.1882 16.5458C18.2155 16.6184 18.246 16.6902 18.2772 16.762C19.0548 18.5328 19.8332 20.3035 20.6109 22.0743C21.5923 24.3088 22.5635 26.5472 23.5597 28.7747C23.8096 29.3337 23.6808 29.849 23.4793 30.3533C23.3122 30.7718 22.7868 30.8265 22.3933 30.4868C21.8327 30.0012 21.2503 29.546 20.6226 29.1518C19.9605 28.7364 19.2773 28.3663 18.4958 28.2203C18.1413 28.154 17.7994 28.1789 17.4644 28.314C17.0741 28.4717 17.0163 28.6294 17.2287 29.0003C17.3981 29.297 17.6588 29.5203 17.8907 29.7631C19.7185 31.6798 21.5556 33.588 23.3872 35.5008C23.5074 35.6265 23.6534 35.7046 23.808 35.7749C24.7879 36.2222 25.7654 36.6758 26.7483 37.1162C27.038 37.2458 27.2371 37.4394 27.3565 37.7345C27.5025 38.0952 27.6727 38.4466 27.825 38.8049C28.0623 39.3655 28.0311 39.4982 27.5783 39.93C27.4018 39.9253 27.2199 39.9253 27.038 39.9253Z"
              />
            </svg>
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> ABP, ABPro y Aprendizaje Basado en Retos</strong>, Técnicas
          Didácticas enfocadas en Aprendizaje Activo
        </div>
      </div>
      <div class="course-catalog-card" style="color: #006ec8">
        <div>
          <div
            class="index-styles"
            @click="scrollToTrainingCard('TrainingCard7')"
          >
            <img
              style="margin: auto"
              class="w-50 h-50"
              :src="training_card_icon_3"
            />
          </div>
        </div>
        <div class="course-catalog-font-header">
          <strong> Aprendizaje </strong>Basado en Casos
        </div>
      </div>
    </div>
    <div class="container-brochure mt-2 mb-5">
      <div class="container-left-right">
        <div class="about-us-img mb-3"></div>
      </div>
      <div class="container-left-right align-self-center">
        <div
          class="w-75 mb-3"
          style="margin-left: auto; margin-right: auto; text-align: left"
        >
          <strong style="font-size: 32px"> Cursos </strong>
          <p style="font-size: 24px">Modalidad Sincrónica</p>
          <p style="font-size: 20px">
            Ofrecemos a las Instituciones de Educación Superior cursos en temas
            metodológicos y didácticos para académicos de las Instituciones de
            Educación Superior, pertinentes para el contexto de procesos en
            enseñanza remota.
          </p>
          <div class="d-flex flex-row">
            <div class="align-self-center">
              <img
                src="../../assets/new-page/Carousel-Beneficios-icono-01.svg"
                alt="Beneficios-icono-01"
              />
            </div>
            <div class="ml-2">
              <div>
                <strong> Relatores </strong>
              </div>
              <div>
                Los(as) relatores(as) son personas expertas de México y Chile.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-menu">
      <a @click="scrollToTrainingCard('TrainingCard1')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°1</a
      >
      <a @click="scrollToTrainingCard('TrainingCard2')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°2</a
      >
      <a @click="scrollToTrainingCard('TrainingCard3')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°3</a
      >
      <a @click="scrollToTrainingCard('TrainingCard4')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°4</a
      >
      <a @click="scrollToTrainingCard('TrainingCard5')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°5</a
      >
      <a @click="scrollToTrainingCard('TrainingCard6')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°6</a
      >
      <a @click="scrollToTrainingCard('TrainingCard7')"
        ><b-icon class="right-menu-icon" icon="caret-right-fill"></b-icon>CURSO
        N°7</a
      >
    </div>

    <TrainingCard
      id="TrainingCard1"
      :tittle="'Diseño de Experiencias de Aprendizaje'"
      :tittle_icon="training_card_icon_1"
      :counter="1"
      :background_card="'#006EC8'"
      :text_color="'#FFFFFF'"
      :highlighted_color="'#FFFFFF'"
      :imagen_left="training_card_img_1"
      :duration_text="'16 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Construye itinerarios de aprendizaje a través del desarrollo de competencias en ambientes de aprendizaje presenciales y no presenciales.'"
      :evaluation_criteria_texts="[
        {
          text: 'Aplica los elementos y momentos clave de una buena clase acorde al contexto en donde se desarrolla el aprendizaje.',
        },
        {
          text: 'Elabora el diseño de una unidad de formación basada en los elementos básicos de experiencia de aprendizaje para un ambiente híbrido.',
        },
      ]"
      :contents_texts="[
        'Tendencias en el diseño de una clase.',
        'Características de los alumnos.',
        'Elementos de diseño para el aprendizaje.',
        'Diseño de Experiencias de aprendizaje.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard2"
      :tittle="'Tecnología Educativa para el aprendizaje'"
      :tittle_icon="training_card_icon_2"
      :counter="2"
      :background_card="'#FFFFFF'"
      :text_color="'#212121'"
      :highlighted_color="'#01ADB7'"
      :imagen_left="training_card_img_2"
      :duration_text="'20 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Aplica las tecnologías educativas para el diseño de sus clases que le permitan mejorar el aprendizaje de los(as) estudiantes.'"
      :evaluation_criteria_texts="[
        {
          text: 'Realiza una tabla comparativa de las herramientas para informar, crear, colaborar, interactuar y evaluar soportada con tecnología educativa. ',
        },
        {
          text: 'Diseña una unidad de formación soportada con tecnología educativa de alguna de sus materias para promover el aprendizaje activo.',
        },
      ]"
      :contents_texts="[
        'Tendencias en tecnologías.',
        'Tecnología educativa (TE) para el aprendizaje y la enseñanza.',
        'Evaluación de TE para el diseño de experiencias.',
        'Modelos de Integración de la TE.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard3"
      :tittle="'Estrategias Integradoras (Pedagogía Colaborativa)'"
      :tittle_icon="training_card_icon_3"
      :counter="3"
      :background_card="'#01ADB7'"
      :text_color="'#F5F5F5'"
      :highlighted_color="'#F5F5F5'"
      :imagen_left="training_card_img_3"
      :duration_text="'20 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Diseña estrategias colaborativas globales, por nivel o por áreas disciplinarias, acorde a las características y particularidades de los estudiantes, que permitan contribuir al logro de los resultados de aprendizaje y de las competencias del perfil del egreso; además de construir nuestro propio conocimiento, conectar con pares y lograr mayor impacto en nuestro contexto del proceso formativo.'"
      :evaluation_criteria_texts="[
        {
          text: 'Presenta acciones de trabajo colaborativo, para mitigar los nudos críticos, considerando las lecturas previas sobre comunidades de aprendizaje.',
        },
        {
          text: 'Diseña la estrategia de trabajo colaborativo, a partir del análisis del diagnóstico de entrada de los estudiantes, y las proyecciones de las asignaturas.',
        },
        {
          text: 'Diseña la planificación integrada de actividades docentes que promueva un aprendizaje inclusivo, considerando el balance de carga de acuerdo a los lineamientos emanados de la innovación curricular en SCT- Chile.',
        },
        {
          text: 'Proyecta vías de seguimiento y evaluación de las acciones colaborativas diseñadas, argumentando sus opiniones sobre la bibliografía del curso.',
        },
      ]"
      :contents_texts="[
        'Elementos de una red de aprendizaje profesional.',
        'Reglas de etiqueta y comunicación.',
        'Construcción e interacción en comunidades de aprendizaje.',
        'Proyectos colaborativos para la innovación.',
        'Proyecta vías de seguimiento y evaluación de las acciones colaborativas diseñadas, argumentando sus opiniones sobre la bibliografía del curso.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard4"
      :tittle="'Retroalimentación efectiva para el Aprendizaje'"
      :tittle_icon="training_card_icon_4"
      :counter="4"
      :background_card="'#FFFFFF'"
      :text_color="'#006EC8'"
      :highlighted_color="'#006EC8'"
      :imagen_left="training_card_img_4"
      :duration_text="'20 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Utiliza los elementos básicos de la retroalimentación en un plan de evaluación de Resultados de Aprendizaje en el contexto de la innovación curricular.'"
      :evaluation_criteria_texts="[
        {
          text: 'Identifica el modelo de feedback que utiliza normalmente al dar retroalimentación a sus alumnos.',
        },
        {
          text: 'Diseña un formato de retroalimentación positiva basado en el Modelo de Hattie & Timperley.',
        },
        {
          text: 'Implementa el modelo de retroalimentación diseñado y realiza una reflexión estructurada sobre los resultados en los dominios de percepción del estudiante, percepción del docente y aprendizaje.',
        },
      ]"
      :contents_texts="[
        'Relación contenido – estudiante – profesor durante el aprendizaje.',
        'Técnicas para retroalimentar el aprendizaje.',
        'Diseño del proceso de evaluación y retroalimentación.',
        'Plan de mejora para el aprendizaje del estudiante.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard5"
      :tittle="'Evaluación del Aprendizaje en un Modelo basado en Competencias'"
      :tittle_icon="training_card_icon_1"
      :counter="5"
      :background_card="'#006EC8'"
      :text_color="'#F5F5F5'"
      :highlighted_color="'#F5F5F5'"
      :imagen_left="training_card_img_5"
      :duration_text="'15 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Aplica un modelo de evaluación de desempeño, sus etapas, métodos y momentos clave para un adecuado seguimiento del desarrollo de competencias en el ambiente educativo.'"
      :evaluation_criteria_texts="[
        { text: 'Diseña un plan integral de evaluación de desempeño.' },
        {
          text: 'Diseña los instrumentos de evaluación acorde al plan:',
          contents: [
            'Rúbrica',
            'Rúbrica binaria',
            'Lista de cotejo',
            'Reflexión estructurada',
            'Escala de apreciación',
            'Registro anecdótico ',
          ],
        },
        {
          text: 'Implementa un proyecto de evaluación del aprendizaje en alguna de sus asignaturas.',
        },
      ]"
      :contents_texts="[
        'Planeación de la evaluación del aprendizaje.',
        'Diseño del proceso evaluativo. Momentos, técnicas, instrumentos.',
        'Implementación de la evaluación del aprendizaje. Proyecto integrador.',
        'Metaevaluación, proceso de mejora continua y nuevos aprendizajes.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard6"
      :tittle="'ABP, ABPro y Aprendizaje Basado en Retos, Técnicas Didácticas enfocadas en Aprendizaje Activo'"
      :tittle_icon="training_card_icon_2"
      :counter="6"
      :background_card="'#FFFFFF'"
      :text_color="'#212121'"
      :highlighted_color="'#01ADB7'"
      :imagen_left="training_card_img_6"
      :duration_text="'15 horas sincrónicas al inicio del curso. Entrega de evidencias de forma asíncrona, 5 horas sincrónicas al finalizar el curso.'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Aplicar las tres técnicas didácticas (ABP, ABPro y ABR) e identificar momentos y experiencias para seleccionar la técnica adecuada, reconociendo las diferencias y sus similitudes.'"
      :evaluation_criteria_texts="[
        {
          text: 'Diseño de un plan de implementación de la técnica didáctica (ABP,ABPro o ABR) en su asignatura que incluya la experiencia detallada de aprendizaje usando la técnica adecuada.',
        },
        { text: 'Utiliza una bitácora de observaciones y seguimiento.' },
        {
          text: 'Utiliza una lista de cotejo de la implementación de la técnica.',
        },
        {
          text: 'Construye una PPT de 2 filminas donde se expliquen los principales aprendizajes al implementar la técnica seleccionada en su curso.',
        },
      ]"
      :contents_texts="[
        'Concepto y características del ABP.',
        'Concepto y características de ABPro.',
        'Concepto y características de ABR.',
        'Selección de la mejor técnica.',
        'Diseño de la experiencia de aprendizaje.',
        'Diseño de la evaluación según la técnica.',
      ]"
    ></TrainingCard>
    <TrainingCard
      id="TrainingCard7"
      :tittle="'Aprendizaje basado en Casos'"
      :tittle_icon="training_card_icon_3"
      :counter="7"
      :background_card="'#01ADB7'"
      :text_color="'#F5F5F5'"
      :highlighted_color="'#F5F5F5'"
      :imagen_left="training_card_img_7"
      :duration_text="'25 horas'"
      :methodology_text="'Mixta con sesiones sincrónicas y actividades asincrónicas.'"
      :ra_text="'Aplicar la metodología de aprendizaje basado en casos como técnica didáctica en sus asignaturas.'"
      :evaluation_criteria_texts="[
        { text: 'Selecciona y adopta un caso para su asignatura.' },
        {
          text: 'Realiza un mapa de argumentos basado en el análisis del caso.',
        },
        {
          text: 'Utiliza un árbol de decisiones para plantear las posibilidades de solución.',
        },
        { text: 'Diseña una presentación de solución del caso.' },
        {
          text: 'Utiliza instrumentos de evaluación de competencias desarrolladas en el proceso de solución del caso.',
        },
      ]"
      :contents_texts="[
        'Fase 0. Actividades previas a la metodología. Sentando las bases.',
        'Fundamentos teóricos y metodológicos del Método del Caso.',
        '¿Qué es un caso? Tipos de casos.',
        'Fase 1. Preparación y análisis del caso.',
        'Discusiones iterativas y debates.',
        'Fase 2. Discusión grupal de alternativas. Pequeños grupos.',
        'Fase 3. Sesión plenaria.',
        'Fase 4. Evaluación del caso y aprendizajes esperados.',
      ]"
    ></TrainingCard>
    <ContactForm></ContactForm>
    <ContactBanner></ContactBanner>
  </div>
</template>

<script>
import training_card_img_1 from "@/assets/new-page/Training_courses_img_1.jpg";
import training_card_icon_1 from "@/assets/new-page/Training_courses_icon_1.svg";
import training_card_img_2 from "@/assets/new-page/Training_courses_img_2.jpg";
import training_card_icon_2 from "@/assets/new-page/Training_courses_icon_2.svg";
import training_card_img_3 from "@/assets/new-page/Training_courses_img_3.jpg";
import training_card_icon_3 from "@/assets/new-page/Training_courses_icon_3.svg";
import training_card_img_4 from "@/assets/new-page/Training_courses_img_4.jpg";
import training_card_icon_4 from "@/assets/new-page/Training_courses_icon_4.svg";
import training_card_img_5 from "@/assets/new-page/Training_courses_img_5.jpg";
import training_card_img_6 from "@/assets/new-page/Training_courses_img_6.jpg";
import training_card_img_7 from "@/assets/new-page/Training_courses_img_7.jpg";
export default {
  name: "TrainingView",
  components: {
    TrainingCard: () => import("@/components/new-page/TrainingCard"),
    ContactForm: () => import("@/components/new-page/ContactForm"),
    ContactBanner: () => import("@/components/new-page/ContactBanner"),
  },
  props: {},
  data() {
    return {
      training_card_img_1,
      training_card_icon_1,
      training_card_img_2,
      training_card_icon_2,
      training_card_img_3,
      training_card_icon_3,
      training_card_img_4,
      training_card_icon_4,
      training_card_img_5,
      training_card_img_6,
      training_card_img_7,
    };
  },
  computed: {},
  methods: {
    scrollToTrainingCard(cardId) {
      const element = document.getElementById(cardId);
      if (element) {
        const yOffset = -5 * 16; // 5em en píxeles y tamaño base de fuente es 16px
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.header-solutions {
  width: 100%;
  height: 140px;
  background: #006ec8;
  border-bottom-right-radius: 40px;
  display: flex;
  align-items: center;
}
.header-font {
  margin-left: 10%;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 100%;
  color: #ffffff;
}
.index-styles {
  display: flex;
  cursor: pointer;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(
    90deg,
    rgba(0, 110, 200, 0.7) 2.51%,
    rgba(1, 173, 183, 0.56) 100.08%
  );
}
.course-catalog-container {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.course-catalog-card {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 12rem;
  margin-bottom: 1rem;
}
.course-link {
  cursor: pointer;
  margin-top: auto;
  text-decoration-line: underline;
  text-transform: uppercase;
}
.course-catalog-font-header {
  margin-left: auto;
  margin-right: auto;
  font-size: 14px;
  margin-bottom: 1rem;
}
.course-catalog-class {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.container-brochure {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-around;
}
.container-left-right {
  display: block;
  width: 50%;
}
.about-us-img {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  height: 365px;
  background: url(../../assets/new-page/Training_img_1.jpg) no-repeat center
    center;
  border-radius: 10px;
  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
@media (max-width: 1000px) {
  .container-brochure {
    flex-direction: column;
  }
  .container-left-right {
    width: 100%;
    text-align: justify;
  }
  .right-menu {
    display: none !important;
  }
}

.right-menu {
  display: block;
  position: fixed;
  bottom: 32%;
  right: 0;
}
.right-menu a {
  display: block;
  position: relative;
  background: #46c5d6;
  max-width: auto;
  margin-bottom: 1px;
  padding: 5px 10px;
  border-radius: 5px 0 0 5px;
  font-size: 1.2em;
  line-height: 1.2em;
  margin: 5px 0px;
  color: #fff;
  font-weight: bold;
  text-align: right;
  text-decoration: none;
  right: calc(-100% + 40px);
  transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -webkittransition: all 0.5s ease-in-out;
}
.right-menu a:after {
  display: inline-block;
  width: 30px;
  font-size: 1.5em;
  text-align: center;
  vertical-align: middle;
  margin-left: 15px;
}
.right-menu a:hover {
  right: 0;
  color: #fff;
  cursor: pointer;
  box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2);
}
.right-menu-icon {
  margin-right: 15px;
}
</style>